import { createSlice } from "@reduxjs/toolkit";
// import moment from "moment";

const initialState = {
  filters: {
    search_text: "",
    customerId: "",
  },
  // sorting: {
  //   sortField: "order_unique_id",
  //   sortDirection: "-1",
  // },
};

const stockProductSlice = createSlice({
  name: "stockProducts",
  initialState,
  reducers: {
    setFilters(state, action) {
      state.filters = { ...state.filters, ...action.payload };
    },
    // setSorting(state, action) {
    //   state.sorting = action.payload;
    // },
    resetFiltersAndSorting(state) {
      state.filters = initialState.filters;
      // state.sorting = initialState.sorting;
    },
  },
});

export const { setFilters, setSorting, resetFiltersAndSorting } = stockProductSlice.actions;
export default stockProductSlice.reducer;
